<div class="row gx-0 px-3 py-2 border-bottom">
  <div class="col col-lg-6 d-flex align-items-center" style="max-width: 320px;">
    <app-local-filter (termChanged)="term = $event; termUpdated.emit($event)" class="w-100"
                      (updated)="updateFiltered($event)" [data]="_data"
                      [placeholder]="'Search'"></app-local-filter>
  </div>
  <div class="col-auto ms-auto">
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    @if (editable) {
      <button class="btn btn-outline-primary text-decoration-none" (click)="addButtonClicked.emit()">
        <i class="button-icon fa-light fa-plus"></i>
        <span class="ps-2 d-none d-md-inline">{{ addText }}</span>
      </button>
    }
  </div>
</div>
<table class="table align-middle">
  <thead class="table-light">
  <tr>
    @for (field of enabledFields; track field.name) {
      @if (field.header) {
        <th scope="col" (click)="sort(field)">
          <span class="sub-text fw-normal">{{ field.header }}</span>
          <i class="fa fa-fw fa-light sub-text"
             [ngClass]="(sortOrder === 'asc' ? 'fa-arrow-down' : 'fa-arrow-up') + (sortField === field ? ' visible ' : ' invisible ')"></i>
        </th>
      } @else {
        <th scope="col" class="auto-width">
        </th>
      }
    }
  </tr>
  </thead>
  <tbody>
    @for (record of filteredData | orderBy: sortField : sortOrder; track record) {
      <tr [ngClass]="rowClassFn ? rowClassFn(record) : ''">
        @for (field of enabledFields; track field.name) {
          <td [ngClass]="field.cellClass">
            @if (field.template) {
              <ng-container [ngTemplateOutlet]="field.template"
                            [ngTemplateOutletContext]="{value: getValueOfRecord(record, field), record: record}"></ng-container>
            } @else {
              @if (field.editable && editMode) {
                @if (field.editTemplate) {
                  <ng-container [ngTemplateOutlet]="field.editTemplate"
                                [ngTemplateOutletContext]="{value: record, field: field}"></ng-container>
                } @else {
                  <input class="form-control w-100 h-100" [ngModel]="getValueOfRecord(record, field)"
                         [type]="fieldType(field)"
                         [step]="field.step"
                         (ngModelChange)="tableView.onFieldChanged(record, field, $event)" [required]="field.required"/>
                }
              } @else {
                <app-highlight [term]="term" [result]="getValueOfRecord(record, field)"></app-highlight>
              }
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>
